import { gql } from '@web/federation/gql'

export const DailyBriefingSectionQuery = gql(`
  query DailyBriefingSectionQuery {
    ...DailyBriefingSection_Query
  }
  
  fragment DailyBriefingSection_Query on Query {
    me {
      ...on MeSucceed {
        todayBookings {
          ...DailyBriefingSection_TodayBookings
        }
      }
    }
  }
  

  fragment DailyBriefingSection_TodayBookings on Booking {
    businessName
    id
    formattedBookingDateText
    isCompleted # 이용완료 여부
    visitId
    addressJson {
      posLat
      posLong
      roadAddr
      jibun
    }
    placeSummary {
      id
      ...TodayBookings_Place
    }
  }

  fragment TodayBookings_Place on PlaceSummary {
    phone
    id
    name
    notExist
    isBookmarked
    notExist
    address {
      rcode
    }
    coordinate {
      latitude
      longitude
    }
    images(display: 1)
    category {
      categoryCodeList
    }
    directionLandingUrl(appName: "m.place.naver.com/my") {
      publicTransit {
        appScheme
        webUrl
      }
      car {
        appScheme
        webUrl
      }
    }
    ...useBookmark_PlaceSummary
  }

`)

export const WeatherQuery = gql(`
  query Weather_Query($input: WeatherInput!) {
    nowWeather(input: $input) {
      ...TodayBookings_Place_Weather
    }
  }
  fragment TodayBookings_Place_Weather on NowWeather {
    region {
      short
    }
    weatherForecast {
      decimalTemperature
      weatherText
      weatherCode
    }
    airForecast {
      pm10 {
        legend
        textColorCode
      }
    }
  }
`)

/**
 * 길찾기 쿼리 (현위치 헤더 전달 필요)
 */
export const DirectionsQuery = gql(`
  query Directions_Query($input: GetDirectionsInput!) {
    directions(input: $input) {
      ...TodayBookings_Place_Directions
    }
  }
  fragment TodayBookings_Place_Directions on Directions {
    car {
      summary {
        duration
        fare
        roadName
      }
    }
    publicTransit {
      summary {
        duration
        fare
        type
      }
    }
  }
`)
